import React, { useContext, useEffect, useState } from 'react';
import { Select, Form, Button, message, Input, Tabs } from 'antd';
import { getTeachers, getStudentsList, createGroups, createStudentGroups } from '../../../actions';
import { Context } from '../../../defaults';



const GroupsAdd = ({
    students,
    setAdded,
    setActive,
}) => {
    const { dictionary, language, setLoading } = useContext(Context);
    const requiredMessage = dictionary?.FillTheField[language];
    const [formValues, setFormValues] = useState();
    const [form] = Form.useForm();


    const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    };

    const initStudents = [];

    const setGroupData = () => {
        setLoading(true);
        form
            .validateFields()
            .then(() => {
                createGroups(formValues)
                    .then(({ data }) => {
                        initStudents.length = 0;
                        formValues.studentsId.forEach((el) => {
                            initStudents.push({ studentId: el, groupId: data });
                        });
                        createStudentGroups(initStudents)
                            .then(() => {
                                setLoading(false);
                                setAdded(true);
                                setActive('2');
                                message.success(dictionary?.SuccessfullyAdded[language], 4);
                                form.resetFields();
                            })
                            .catch(() => {
                                setLoading(false);
                                message.error(dictionary?.SomethingWentWrong[language], 4);
                            });
                    })
                    .catch(() => {
                        setLoading(false);
                        message.error(dictionary?.SomethingWentWrong[language], 4);
                    });
            })
            .catch(() => {
                setLoading(false);
                message.error(dictionary?.FormValidationFail[language], 4);
            });
    };

    return (
        <React.Fragment>
            <Form form={form} layout='horizontal' labelCol={{ span: 7 }} style={{ marginTop: 30 }} wrapperCol={{ span: 10 }}>
                <Form.Item
                    name='name'
                    label={dictionary?.Name[language]}
                    rules={[{ required: true, message: requiredMessage }]}>
                    <Input
                        onChange={(data) => setFormValues({ ...formValues, name: data.target.value })}
                        placeholder={dictionary?.Name[language]}
                    />
                </Form.Item>
                <Form.Item
                    label={dictionary?.StudentsList[language]}
                    name='studentsId'
                    rules={[{ required: true, message: requiredMessage }]}>
                    <Select
                        mode='multiple'
                        showSearch={true}
                        allowClear={true}
                        onChange={(data) => setFormValues({ ...formValues, studentsId: data })}
                        placeholder={dictionary?.StudentsList[language]}
                        filterOption={(search, item) => {
                            return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                        }}
                    >
                        {students &&
                            students.map((el) => {
                                return (
                                    <Select.Option value={el.id} key={el.id}>
                                        {`${el.firstName} ${el.middleName} ${el.lastName}`}
                                    </Select.Option>
                                );
                            })}
                    </Select>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type='primary' onClick={setGroupData}>
                        {dictionary?.Save[language]}
                    </Button>
                </Form.Item>
            </Form>
        </React.Fragment>
    );

}

export default GroupsAdd;